import styled from "styled-components";

export const DialogStyles = styled.div`
  hr {
    height: 5px;
  }
`;

export const DialogButton = styled.button`
  width: ${(props) => (props.p11 ? "25%" : "62%")};
  /* background: ${(props) =>
    props.colorBackground
      ? props.colorBackground
      : props.theme.palette.background.main}; */
  padding: 0;
  transition: 200ms ease;
  border: none;
  cursor: pointer;

  @media (min-width: 900px) {
    width: ${(props) => (props.p11 ? "25%" : "15vw")};
    background-color: transparent;
  }

  &:hover {
    /* background: ${(props) =>
      props.colorBackgroundHover
        ? props.colorBackgroundHover
        : props.theme.palette.drawer.light}; */
    ${(props) =>
      props.p11 ? "filter: brightness(75%);" : "transform: scale(1.1)"};
    z-index: 1000;
  }

  &:focus {
    outline: none;
  }

  img {
    width: 100%;
  }

  ${(props) => (props.clicked ? "filter: grayscale(100%)" : "")};
`;

export const ButtonText = styled.button`
  background: ${(props) =>
    props.colorBackground
      ? props.colorBackground
      : props.theme.palette.background.main};
  transition: 200ms ease;
  border: none;
  padding: 1vw 2vw;
  border-radius: 15px;
  color: ${(props) => (props.colorText ? props.colorText : "#fff")};
  text-transform: uppercase;
  > p {
    font-weight: bolder;
    text-indent: 0;
  }
  cursor: pointer;

  @media (max-width: 900px) {
    padding: 1rem 1.5rem;
  }

  &:hover {
    background: ${(props) =>
      props.colorBackgroundHover
        ? props.colorBackgroundHover
        : props.theme.palette.drawer.light};
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }

  ${(props) => (props.clicked ? "filter: grayscale(100%)" : "")};
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;

  &:focus {
    outline: none;
  }

  img {
    width: 2rem;
  }
`;
